import types from './mutation-types'

export default {
    [types.UPDATE_FILTER](state, filter) {
        state.filter = {...state.filter, ...filter};
    },

    [types.RESET_FILTER](state) {
        state.filter = {
            dateRange  : null,
            search     : null,
            location_id: null,
            campaign_id: null,
            region_id  : null,
            tag_id     : null,
            fixedDateRange:null,
        }
    },

    activeChatMessenger(state, value) {
        state.isActiveChatMessenger = value
    }
}
